import { SPIRITS_1 } from "./part1";
import { SPIRITS_2 } from "./part2";
import { SPIRITS_3 } from "./part3";
import { SPIRITS_EN } from "./en";

export const SPIRITS = [...SPIRITS_1, ...SPIRITS_2, ...SPIRITS_3];

export const RANK_EN = {
  Rei: "King",
  Duque: "Duke",
  Príncipe: "Prince",
  Prelado: "Prelate",
  Marquês: "Marquess",
  Presidente: "President",
  Cavaleiro: "Knight",
  Conde: "Earl",
};

export const localizeSpirit = (s, lang) =>
  lang === "en"
    ? { ...s, ...(SPIRITS_EN[s.slug] || {}), ranks: s.ranks.map((r) => RANK_EN[r] || r) }
    : s;

export const localizeSpirits = (lang) => SPIRITS.map((s) => localizeSpirit(s, lang));

export const GOETIA_SOURCES = [
  "Ars Goetia — in Lemegeton Clavicula Salomonis (The Lesser Key of Solomon), S. L. MacGregor Mathers edition (1904)",
  "Pseudomonarchia Daemonum — Johann Weyer (1583)",
  "Dictionnaire Infernal — J. A. S. Collin de Plancy (1863)",
];

export const RANK_FILTERS = [
  { id: "todos", match: () => true },
  { id: "reis", match: (s) => s.ranks.includes("Rei") },
  { id: "duques", match: (s) => s.ranks.includes("Duque") },
  { id: "principes", match: (s) => s.ranks.includes("Príncipe") || s.ranks.includes("Prelado") },
  { id: "marqueses", match: (s) => s.ranks.includes("Marquês") },
  { id: "presidentes", match: (s) => s.ranks.includes("Presidente") },
  { id: "cavaleiros", match: (s) => s.ranks.includes("Cavaleiro") },
  { id: "condes", match: (s) => s.ranks.includes("Conde") },
];

export const getSpirit = (slug) => SPIRITS.find((s) => s.slug === slug);

export const padNum = (n) => String(n).padStart(2, "0");
